import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";

/**
* class HSN.ClickToCallModal
*
* Encapsulates the functionality of a modal dialog that a customer can use to submit a request to have CS call them
**/
HSN.ClickToCallModal = (function (parent) {
    __extends(ClickToCallModal, parent);

    function ClickToCallModal() {
        var modal = ClickToCallModal.__super__.constructor.call(this);
        this.Close.off();
        this.customerPhoneNumber = null;
        eventHandlers(this);
        return modal;
    }

    function eventHandlers(modal) {

        $(modal.Close).on('click', function () {
            closeModal(modal);
        });

        $(modal.Content).on('click', '#call-btn', function () {
            modal.putCustomerPhone();
            return false;
        });

        $(modal.Content).on('click', '.cancel-btn', function () {
            closeModal(modal);
            return false;
        });

    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.ClickToCallModal#Show() -> void
    * - data (object): customer object
    **/
    ClickToCallModal.prototype._show = function (data) {
        this.customerPhoneNumber = this.cleanPhoneNumber(data.customerPhoneNumber);
        $.ajax(
            '/myaccount/clicktocall/modal/get?CustomerPhone=' + this.customerPhoneNumber,
            {
                context: this,
                dataType: 'html',
                data: {},
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    this.Content.showHtml
                    (
                        data,
                        0,
                        function () {
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 });
                            __scope.customerPhone = $('.click-to-call-phone').val();
                            HSN.FormatPhone('.click-to-call-phone');
                            $(__scope.Root).find('.click-to-call-phone').focus();
                            $(__scope.Root).find('.click-to-call-phone').blur();
                        },
                        function () {
                            //__scope.Center();
                        }
                    );

                },
                error: function (xhr, status, error) {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };

    ClickToCallModal.prototype.putCustomerPhone = function () {
        var scope = this;
        this.customerPhoneNumber = this.cleanPhoneNumber($(this.Root).find('.click-to-call-phone').val());
        $(this.Content).find('#validation-errors').html('');
        $.ajax('/api/clicktocall/callback?phoneNumber=' + this.customerPhoneNumber,
            {
                type: 'POST',
                context: this,
                dataType: 'json',
                success: function (data) {
                    if (data.ServiceAvailable && data.Successful) {
                        scope.renderConfirmation(data.EstimatedWaitTime);
                    }
                    else if (data.Errors) {
                        scope.renderValidationErrors(data.Errors);
                    }
                    else {
                        scope.renderError();
                    }
                },
                error: function () {
                    scope.renderError();
                }
            }
        );
    };

    ClickToCallModal.prototype.renderConfirmation = function (timeInMinutes) {
        var scope = this;
        $(this.Content).find('.wait-time-confirmation').text(timeInMinutes);
        $(this.Content).find('.minutes-text').text(this.pluralize(timeInMinutes, 'minute'));
        $(this.Content).find('.click-to-call-input').hide();
        $(this.Content).find('.click-to-call-complete').show();
        scope.Center();
    };

    ClickToCallModal.prototype.renderError = function () {
        var scope = this;
        $(this.Root).find('.click-to-call-input').hide();
        $(this.Root).find('.click-to-call-error').show();
        scope.Center();
    };

    ClickToCallModal.prototype.pluralize = function (count, noun, suffix = 's') {
        return count !== 1 ? noun + suffix : noun;
    };

    ClickToCallModal.prototype.cleanPhoneNumber = function (phoneNumber) {
        return phoneNumber.replace(/\D+/g, '');
    };

    ClickToCallModal.prototype.renderValidationErrors = function (errors) {
        var errorElement = $('<div class="errors" tabindex="-1"><div class="errors-top"><span><b>OOPS.</b> Please fix the following:</span></div><ul></ul></div>');
        for (var currentError = 0; currentError < errors.length; currentError++) {
            errorElement.find('ul').append('<li>' + errors[currentError].Message + '</li>');
        }
        $(this.Content).find('#validation-errors').append(errorElement);
    };

    return ClickToCallModal;

})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/MyAccount/ClickToCallModal.js